
/**
 * Reference to the Config File Model
 */
export class ConfigFileModel {
	public api: ApiServices;
	public external_app?: any;
	public oidc_configuration?: IDSConfig;
	public helpdesk?: HelpdeskConfig;
	public publicKey?: {
		googleMaps: string;
	};
	public version: AppVersion;
	public cookiesConfig : {
		enabled : boolean
	}
}

/**
 * State of the App from Git
 */
export class AppVersion {
	public name?: string;
	public environment?: string;
	public tag?: string;
	public committedOn?: string;
	public modules?: any;
	public dependencies?: Array<DependenciesVersion>;
}

export interface ApiServices {
	[optionName: string]: any;
}

export class DependenciesVersion {
	name: string;
	component: string;
	type: string;
	version: string;
}

export class IDSConfig {
	authority?: string;
    redirectUrl?: string;
    clientId?: string;
    responseType?: string;
    scope?: string;
    postLogoutRedirectUri?: string;
    disableRefreshIdTokenAuthTimeValidation?: boolean;
    silentRenew?: boolean;
    useRefreshToken?: boolean;
    maxIdTokenIatOffsetAllowedInSeconds?: number;
	storage?: any;
}

/**
 * Help Center / Helpdesk configuration loaded from config.json
 */
export class HelpdeskConfig {
	/** Base URL for the help center support API */
	api?: string;
}
